import {CommonMessages} from '../common.messages';

export const PanelAccountsEditRiskSettingsMessages = {
    GetAccountHardBuyingPowerFailed: {
        key: 'GetAccountHardBuyingPowerFailed',
        message: 'Error while processing request to the server. Unable to get the account\'s Hard BP.'
    },
    UpdateAccountHardBuyingPowerFailed: {
        key: 'UpdateAccountHardBuyingPowerFailed',
        message: 'Error while processing request to the server. Unable to update the account\'s Hard BP.'
    },
    UpdateAccountHardBuyingPowerSucceed: {
        key: 'UpdateAccountHardBuyingPowerSucceed',
        message: 'Hard BP updated.'
    },
    AccountHardBuyingPowerUnavailable: {
        key: 'AccountHardBuyingPowerUnavailable',
        message: 'Hard BP is not available for this account.'
    },
    AccountHardBuyingPowerNoCeiling: {
        key: 'AccountHardBuyingPowerNoCeiling',
        message: 'The group has no Total Hard BP ceiling.'
    },
    ...CommonMessages
};
